export default __webpack_public_path__ + "static/media/x-button.75e0654f.svg";